import React, { useEffect, useState } from "react";
import { Dialog, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BuzzerForceOverlay = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("buzzer-force-open", handler);
    return () => {
      window.removeEventListener("buzzer-force-open", handler);
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const buzzerUrl = `${window.location.origin}/buzzer`;

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: "#000",
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 10,
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ width: "100%", height: "100%" }}>
        <iframe
          title="Beat the Buzzer"
          src={buzzerUrl}
          style={{
            border: "none",
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </Dialog>
  );
};

export default BuzzerForceOverlay;

